module.exports = __webpack_public_path__ + "assets/previous-white.fcaa8b42.svg";